// ----------------------------------------------------------------------

// 如果此翻译不正确，请忽略，因为此翻译仅用于演示目的
// 如果您可以帮助改进翻译，我们非常乐意，请发送电子邮件至 support@minimals.cc。

// ----------------------------------------------------------------------

const cn = {
  dashboard: '仪表盘',
  my_loans: '我的贷款',
  notification: '通知',
  wait_while_profile_being_verified: '请耐心等待，您的个人资料正在审核中。',
  account: '账户',
  chat: '聊天',
  online_bank_account: '网上银行账户',
  x_is_required: '必须填写 {{x}}',
  bank: '银行',
  account_number: '账号',
  x_must_be_y_to_z_digits_in_length: '{{x}} 长度必须为 {{y}}-{{z}} 位数字',
  payment: '付款',
  total_payment: '总付款',
  wrong_otp: 'OTP 错误',
  refer_a_friend: '推荐好友',
  apply_loan_details: '贷款申请详情',
  my_listing: '我的列表',
  edit_profile: '编辑资料',
  extra_documents: '额外文件',
  employer_name: '雇主名称',
  employer_contact_number: '雇主联系电话',
  upload_payslip_for_last_month: '上传上个月工资单',
  upload_bank_statement_salary_last_month: '上传上个月工资银行对账单',
  upload_utility_bill_last_month: '上传上个月的水电账单',
  upload_active_mortgage_statement: '上传现有房贷对账单',
  dont_worry_your_data_is_kept_protected: '请放心，您的数据依法保存并受到我们的保护！',
  nric_front: '身份证正面',
  upload_nric_front: '上传身份证正面',
  nric_back: '身份证反面',
  upload_nric_back: '上传身份证反面',
  nric_number: '身份证号',
  complete_profile_to_submit_loan_application: '请完善您的资料后再提交贷款申请。',
  name_as_per_ic: '身份证上的姓名',
  view_example: '查看示例 >',
  upload_video_selfie_together_with_nric_x_appname: '上传手持身份证的视频自拍，说出您的姓名以申请 {{x}}',
  emergency_contact_1: '紧急联系人 1',
  emergency_contact_2: '紧急联系人 2',
  relationship: '关系',
  name: '姓名',
  done: '完成',
  data_is_being_prep: '数据正在准备中',
  loan_application_failed: '贷款申请失败！',
  title_: '标题：',
  message_: '信息：',
  contact_support: '联系客服',
  ok: '确定',
  receive_method: '收款方式',
  select_bank: '选择银行',
  key_in_account_number: '输入账号',
  congratulations: '恭喜！',
  your_loan_has_been_approved: '您的贷款已获批！',
  payment_amount_xcurrencyx: '付款金额 ({{x}})',
  interest: '利息',
  underwriting_fee: '承保费',
  gateway_fee: '通道费',
  service_fee: '服务费',
  deposit: '押金',
  total_amount_received: '到账总额',
  apply_now: '立即申请',
  application_submitted_wait_pic_to_serve_u: '您的申请已提交，请等待我们的负责人为您服务。',
  mobile_number: '手机号',
  _due_: ' 截止：',
  pay_now: '立即付款',
  recent_transactions: '最近交易',
  no_loan_yet: '暂无贷款',
  no_notification: '暂无通知...',
  enter_any_payment_amount: '输入任意付款金额',
  select_payment_method: '选择付款方式',
  invite_your_friend_to_x_app: '邀请朋友加入 {{x}} 应用！',
  about_x: '关于 {{x}}',
  upload_receipt_x_will_verify_payment: '请上传 ATM / 现金存款收据，{{x}} 将在 3 个工作日内核实您的付款。',
  pay_to_either_one_of_x_accounts: '使用 ATM 或现金存款支付到以下任一 {{x}} 账户：',
  youre_one_step_away_x_click_next_to_proceed: '您距离享受 {{x}} 的好处仅一步之遥。点击下一步继续。',
  welcome_to_x: '欢迎来到 {{x}}',
  share_now: '立即分享',
  copy: '复制',
  your_referral_history: '您的推荐记录',
  share_your_referral_code: '分享您的推荐码',
  how_referral_works: '推荐如何运作',
  copied: '已复制',
  how_referral_works_x_y_commission: '我们的佣金规则让推荐人可从受邀人的首次贷款和后续贷款分别获得 {{x}} 和 {{y}}。当受邀人完成全额还款后，这些佣金将发放给推荐人。',
  customer_support: '客服支持',
  date: '日期',
  amount: '金额',
  status: '状态',
  enter_payment_amount: '输入付款金额',
  entered_amount_more_than_you_owe: '输入的金额超过应付金额。',
  oops_we_are_sorry: '抱歉，很遗憾',
  more_time_needed_will_inform_once_completed: '需要更多时间，完成后我们会通知您。',
  contact_us: '联系我们',
  proceed_to_online_banking_to_pay_loan: '前往网上银行支付贷款',
  proceed: '继续',
  thank_you_for_payment: '感谢您的付款！',
  please_register_an_account: '请注册账户',
  referral_code_optional: '推荐码（可选）',
  register: '注册',
  downline_name: '下线姓名',
  no_: '编号',
  total_commission: '总佣金',
  total_withdrawal: '总提现',
  balance: '余额',
  total_register_: '注册总数：',
  total_loans_: '贷款总数：',
  upload_your_receipt: '上传收据',
  email_address: '电子邮箱',
  password: '密码',
  forget_password: '忘记密码',
  sign_in: '登录',
  upload_photo: '上传照片',
  title: '标题',
  edit: '编辑',
  delete: '删除',
  view: '查看',
  no: '否',
  yes: '是',
  phone_number: '电话号码',
  save: '保存',
  forgot_password: '忘记密码',
  submit: '提交',
  please_verify_account_first: '请先验证账户',
  are_you_ready_to_nbe_a_part_of_the_family: '你准备好\n成为这个家庭的一员了吗？',
  full_name: '全名',
  verify_account: '验证账户',
  skip: '跳过',
  next: '下一步',
  let_s_get_started: '让我们开始吧',
  please_enter_otp: '请输入发送到您号码的 OTP',
  new_password: '新密码',
  please_enter_your_nnew_password_to_reset_your_password: '请输入新密码以重置密码',
  confirm_password: '确认密码',
  reset_password: '重置密码',
  welcome_back_yo_ve_nbeen_missed: '欢迎回来，我们很想你！',
  let_s_sign_you_in: '让我们帮你登录。',
  choose_your_language: '请选择您的语言开始！',
  login_now: '立即登录。',
  sign_up: '注册',
  log_in: '登录',
  empty_field_found: '发现空字段',
  invalid_x: '无效的 {{x}}',
  invalid_nric_please_enter_x_format: '请输入有效的香港或澳门身份证号码（8-9个字符）。不带括号',
  something_went_wrong_x: '出错了：{{x}}',
  something_went_wrong_pls_contact_support: '出错了。请联系客服。',
  enter_valid_mobile_no: '请输入有效手机号。',
  record_already_exists: '记录已存在',
  x_already_exists: '{{x}} 已存在！',
  permission_turned_off_can_be_enabled_in_app_settings: '您似乎已关闭此功能所需权限，可在应用设置中启用！',
  go_to_settings: '前往设置',
  cancel: '取消',
  payment_info: '付款信息',
  no_amount_and_id_found: '未找到金额和 ID',
  name_of_correspondence: '联系人姓名',
  number_of_correspondence: '联系人电话',
  emergency_contact_1_2_x_shouldnt_be_the_same: '紧急联系人 1 和 2 {{x}} 不应相同',
  referral_history: '推荐记录',
  withdrawal_history: '提现记录',
  loan_packages: '贷款套餐',
  ensure_settle_payment_b4_due_date_to_avoid_penalty: '请确保在截止日期前结清款项，以免产生罚金。',
  period: '期限',
  identity_nverification: '身份验证',
  threemin_nreview: '3 分钟审核',
  threemin_nreceival: '3 分钟到账',
  identity: '身份',
  verification: '验证',
  threemin: '3 分钟',
  review: '审核',
  receival: '到账',
  nric_name: '身份证姓名',
  _days: ' 天',
  details: '详情',
  announcements: '公告',
  no_internet_connection: '无网络连接',
  retry: '重试',
  code_sent: '验证码已发送',
  otp_verification_failed: 'OTP 验证失败',
  invalid_credential: '凭证无效',
  firebase_quota_exceeded: '配额超出',
  wrong_otp_code: 'OTP 错误',
  too_many_request_detected: '请求过多，请稍后再试',
  account_submitted: '账户信息已提交',
  loan_application_submitted: '贷款申请已提交',
  please_wait_our_admin_to_contact_you_soon: '请等待管理员尽快联系您。',
  whats_app_no: 'WhatsApp 号码',
  invite_message_x_referral_code_x: '嘿，我发现一个零利息贷款应用。{{x}} 我的推荐码是 {{y}}',
  nric_format_name: 'MyKad 号码（无横杠）',
  nric_min_length_x: '最小长度为 {{x}}',
  select_country_region: '选择国家/地区',
  request_contact_list_permission_reason: '我们需要访问您的联系人列表以帮助检测和防止欺诈。通过将您的联系人与我们的数据库对比，我们可以识别任何可疑活动，帮助保障您的账户和个人信息安全。',
  permission_request: '权限请求',
  app_wont_work_without_permission: '没有以下权限，应用将无法使用：',
  go_to_app_settings_allow_permission_manually: '请前往应用设置并手动允许权限',
  allow: '允许',
  take_photo_using_camera: '使用相机拍照',
  select_photo_from_gallery: '从相册选择照片',
  select_pdf_file: '选择 PDF 文件',
  failed_to_attach_photo: '照片附件失败',
  signup_agree_privacy_policy: '注册即表示您同意我们的隐私政策。',
  login_agree_privacy_policy: '登录即表示您同意我们的隐私政策。',
  request_upload_photo_permission_reason: '我们需要您的许可，将设备中的照片安全上传到服务器用于 KYC 认证。未经您的明确同意，我们不会与任何第三方分享您的照片。',
  upload_failed_please_try_again: '上传失败，请重试',
  loan_payment_failed: '贷款付款失败',
  complete_kyc_note: '为了加快您的贷款审批流程，请完善 KYC（了解您的客户）资料，这将帮助我们更好地为您服务！',
  driver_license_front: '身份证正面',
  driver_license_back: '身份证反面',
  passport_info_page: '护照信息页',
  passport_cover_page: '护照封面页',
  total_payable_amount: '应付款总额',
  profile: `轮廓`,
  easy: `简单的`,
  easy_desc: `简单快捷的解决方案就在指尖`,
  fast: `快速地`,
  fast_desc: `立即在您的银行账户中获得贷款`,
  secure: `安全的`,
  secure_desc: `我们使用最高级别的安全措施来存储您的数据`,
  enter_loan_amount: '输入贷款金额',
  minimum_amount: '最低金额:',
  maximum_amount: '最高金额:',
  apply_loan_note: '保持您的帐户活跃，建立信任并按时偿还贷款以增加您的限额',
};

export default cn;
